import { getSentimentTypes } from '@/metrics/pages/ReasonMetricDetailPage/helpers'

export const getSentimentLabel = (sentiment, theme) => getSentimentTypes(theme)[sentiment]?.label || null
